import type { IntlFormatters } from 'react-intl';

type IntlFormatMessage = IntlFormatters['formatMessage'];

export const humanizeDistance = (
  distance: number,
  formatMessage: IntlFormatMessage,
) =>
  ({
    1: formatMessage({ id: 'XER_ORDINAL_FIRST' }),
    2: formatMessage({ id: 'XER_ORDINAL_SECOND' }),
  }[distance] || undefined);
